package game.controller

import game.CgaColor
import game.Game
import view.Terminal

typealias CheckEvent = (Boolean, Game) -> Unit

class CheckBox(text: String, col: Int, row: Int, width: Int, height: Int, var checked: Boolean = true) :
    Component(text, col, row, width, height) {

    var onCheck: CheckEvent = {checked, godlair->}

    override fun render(game: Game, terminal: Terminal) {
        val prefix = if (checked) "[X]" else "[ ]"

        val text = "$prefix $text"

        terminal.drawString(col, row, text, CgaColor.LIGHT_GRAY, CgaColor.BLACK)
    }

    override fun click(game: Game) {
        checked = !checked

        onCheck.invoke(checked, game)
    }
}